/**
 *  @module geo/functionalities
 */

import {Observable} from 'rxjs/Observable';
import {Functionality} from '.';
import { InfoSheetResultsType } from '../types/functionality/infosheet';

/**
 * 
 */
export interface InfoSheetOptions {
  /**
   * open in edit mode
   */
  edit?: boolean;
  /**
   * display thhe edition button
   */
  editable?: boolean;
  /**
   * The title of the infoshhet dialog
   */
  featureLabel?: string;
  /**
   * hash of initial values in edition mode
   */
  initialValues?: any;
  /**
   *  always force open new infosheet
   */
  forceOpen?: boolean;
}

/**
 * infosheet execution parameters
 */
export interface InfoSheetExecutionParameters {
  feature: string;
  options: InfoSheetOptions;
}
/**
 * Desactivation options
 */
export interface InfoSheetDisableOptions {
  /**
   * unique id of open infosheet container
   */
  uniqueId?: string;
}
/**
 * Infosheet functionality class.
 * 
 * To open infosheet for a feature :
 * 
 * ```javascript
 * geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute({
 *      feature : "12",
 *      options: {
 *        featureLabel: "Infosheet for object of id 12"
 *      }
 * });
 * ```
 * 
 * To open infosheet for new object :
 * 
 *  ```javascript
 * geoApp.getFunctionalityByName('Infosheet observation')[0].execute({
 *      feature : "new",
 *      options: {
 *         edit: true,
 *         editable: true,
 *         featureLabel: "My new feature",
 *         initialValues:{
 *           name:'new object',
 *           value: 10
 *         }
 *      }
 * });
 * ```
 * 
 */
export class InfoSheetFunctionality extends Functionality {

  _results:InfoSheetResultsType = {opened:[]};
  
  getService() {
    throw new Error('Method not implemented.');
  }

  public static typeDef = 'com.bg.functionality.infosheet.InfoSheet';
  /**
   * Open infosheet
   *
   * - to open new infosheet in edit mode
   * ```
   * geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
   *  {feature:null,options:{edit:true,editable:true}}
   * );
   * ```
   *
   * - to open infosheet in view mode on a feature
   * ```
   * geoApp.getFunctionalityById('8e1aca07-30a4-11e8-8810-9787e286647e').execute(
   *  {feature:'65',options:{edit:false,editable:true}}
   * );
   * ```
   * @since v2.0.2
   * 
   * 
   */
  public execute(parameters: InfoSheetExecutionParameters): Observable<any> {
    return super.execute(parameters);
  }

  /**
   * Close infosheet.
   * If several popup are open it is possible to close one with options= {uniqueId:'xxx'} (see results.opened)
   * To close all call disable with no options
   */
  public disable(options:InfoSheetDisableOptions): Observable<any>{
    return super.disable(options);
  }
}